import { template as template_02dceaba80cb4edc80a2abc0f0d6120b } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import { cn } from '../-private/helpers/cn.ts';
export interface VelvetTagSignature {
    Args: {
        /// Indicate if the tag is pill shaped.
        /// @default [false]
        isPill?: boolean;
        /// The size of the tag.
        /// @default ["md"]
        size?: 'sm' | 'md' | 'lg';
        /// The appearance of the tag.
        /// @default ["primary"]
        variant?: string | 'primary';
    };
    Blocks: {
        /// The label of the tag.
        default: [];
    };
    Element: HTMLDivElement;
}
const VelvetTag: TOC<VelvetTagSignature> = template_02dceaba80cb4edc80a2abc0f0d6120b(`
  <div
    class={{cn
      "velvet-tag"
      (concat "velvet-tag-" (or @size "md"))
      (concat "velvet-tag-" (or @variant "primary"))
      (if @isPill "velvet-tag-pill")
    }}
    ...attributes
  >
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default VelvetTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3ZlbHZldC10aHVuZGVyL3ZlbHZldC10aHVuZGVyL3ZlbHZldC10aHVuZGVyL3NyYy9jb21wb25lbnRzL3ZlbHZldC10YWcuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgVE9DIH0gZnJvbSAnQGVtYmVyL2NvbXBvbmVudC90ZW1wbGF0ZS1vbmx5JztcbmltcG9ydCB7IGNvbmNhdCB9IGZyb20gJ0BlbWJlci9oZWxwZXInO1xuaW1wb3J0IHsgb3IgfSBmcm9tICdlbWJlci10cnV0aC1oZWxwZXJzJztcbmltcG9ydCB7IGNuIH0gZnJvbSAnLi4vLXByaXZhdGUvaGVscGVycy9jbi50cyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgVmVsdmV0VGFnU2lnbmF0dXJlIHtcbiAgQXJnczoge1xuICAgIC8vLyBJbmRpY2F0ZSBpZiB0aGUgdGFnIGlzIHBpbGwgc2hhcGVkLlxuICAgIC8vLyBAZGVmYXVsdCBbZmFsc2VdXG4gICAgaXNQaWxsPzogYm9vbGVhbjtcblxuICAgIC8vLyBUaGUgc2l6ZSBvZiB0aGUgdGFnLlxuICAgIC8vLyBAZGVmYXVsdCBbXCJtZFwiXVxuICAgIHNpemU_OiAnc20nIHwgJ21kJyB8ICdsZyc7XG5cbiAgICAvLy8gVGhlIGFwcGVhcmFuY2Ugb2YgdGhlIHRhZy5cbiAgICAvLy8gQGRlZmF1bHQgW1wicHJpbWFyeVwiXVxuICAgIHZhcmlhbnQ_OiBzdHJpbmcgfCAncHJpbWFyeSc7XG4gIH07XG4gIEJsb2Nrczoge1xuICAgIC8vLyBUaGUgbGFiZWwgb2YgdGhlIHRhZy5cbiAgICBkZWZhdWx0OiBbXTtcbiAgfTtcbiAgRWxlbWVudDogSFRNTERpdkVsZW1lbnQ7XG59XG5cbmNvbnN0IFZlbHZldFRhZzogVE9DPFZlbHZldFRhZ1NpZ25hdHVyZT4gPSA8dGVtcGxhdGU-XG4gIDxkaXZcbiAgICBjbGFzcz17e2NuXG4gICAgICBcInZlbHZldC10YWdcIlxuICAgICAgKGNvbmNhdCBcInZlbHZldC10YWctXCIgKG9yIEBzaXplIFwibWRcIikpXG4gICAgICAoY29uY2F0IFwidmVsdmV0LXRhZy1cIiAob3IgQHZhcmlhbnQgXCJwcmltYXJ5XCIpKVxuICAgICAgKGlmIEBpc1BpbGwgXCJ2ZWx2ZXQtdGFnLXBpbGxcIilcbiAgICB9fVxuICAgIC4uLmF0dHJpYnV0ZXNcbiAgPlxuICAgIHt7eWllbGR9fVxuICA8L2Rpdj5cbjwvdGVtcGxhdGU-O1xuXG5leHBvcnQgZGVmYXVsdCBWZWx2ZXRUYWc7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUMxRCxTQUFTLE1BQU0sUUFBUSxnQkFBZ0I7QUFDdkMsU0FBUyxFQUFFLFFBQVEsc0JBQXNCO0FBQ3pDLFNBQVMsRUFBRSxRQUFRLDRCQUE0QjtBQUUvQyxpQkFBaUI7SUFDZjtRQUNFLHVDQUF1QztRQUN2QyxvQkFBb0I7UUFDcEIsU0FBUyxPQUFPO1FBRWhCLHdCQUF3QjtRQUN4QixtQkFBbUI7UUFDbkIsT0FBTyxPQUFPLE9BQU87UUFFckIsOEJBQThCO1FBQzlCLHdCQUF3QjtRQUN4QixVQUFVLE1BQU0sR0FBRzs7SUFFckI7UUFDRSx5QkFBeUI7UUFDekI7O0lBRUYsU0FBUzs7QUFHWCxNQUFNLFdBQVcsSUFBSSxzQkFBc0IsMENBQVUsQ0FBQTs7Ozs7Ozs7Ozs7O0FBWXJELENBQUEsRUFBQTtJQUFBO1FBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO0lBQUQ7QUFBQTtBQUVWLGVBQWUsVUFBVSJ9